import '../../assets/components/ProductCard/productcard.css';const t = "_productcardButton_1e2hz_1", e = "_productcard_1e2hz_1", o = "_body_1e2hz_25", _ = "_imageWrapper_1e2hz_30", a = "_image_1e2hz_30", r = "_details_1e2hz_41", c = "_name_1e2hz_47", s = "_footer_1e2hz_59", d = "_footertextEmphasis_1e2hz_68", n = {
  productcardButton: t,
  productcard: e,
  body: o,
  imageWrapper: _,
  image: a,
  details: r,
  name: c,
  footer: s,
  footertextEmphasis: d
};
export {
  o as body,
  n as default,
  r as details,
  s as footer,
  d as footertextEmphasis,
  a as image,
  _ as imageWrapper,
  c as name,
  e as productcard,
  t as productcardButton
};
